var EPK = EPK || {};

EPK.ProductList = EPK.ProductList || {};
EPK.ProductList = function(){};

EPK.ProductCommon = EPK.ProductCommon || {};
EPK.ProductCommon = function(){};

EPK.ProductCommonParams = EPK.ProductCommonParams || {};

$(function(){
	var ProductList = new EPK.ProductList();

	EPK.ProductCommon.getMinPrice('detail', 7, 0);
	EPK.ProductCommon.getMinPrice('recommend', 2, 1);
	EPK.ProductCommon.getMinPrice('new', 2, 1);

	EPK.ProductCommon.getItemShopCount('detail', 1);

	// リスト表示切替
	$('.viewlist > div').on('click', function () {
		var $th = $(this).index();
		$('.viewlist > div').removeClass('active');
		$('.p-product-wrap').removeClass('active');
		$(this).addClass('active');
		$('.p-product-wrap').eq($th).addClass('active');
	});
});
